import '../Popup.css'
import React, { useState, useEffect } from 'react'
import { getEnv } from '../config/env'

const TSPopup = ({ isOpen, children, onClose, tableTitle }) => {
  const [comment, setComment] = useState('')
  const [columns, setColumns] = useState([])
  const [tableData, setTableData] = useState([])
  const [unique_values, setUniqueValues] = useState([])

  const getColumns = async () => {
    const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/column_names`, {
      table: tableTitle.title
    })
    console.log(response)
    setColumns(response.columns)
    setTableData(response.data)
  }

  useEffect(() => {
    if (isOpen) {
      getColumns()
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleInputChange = (e) => {
    setComment(e.target.value)
  }

  const handleColumnClick = async (column) => {
    const response = await window.PDR.api.post(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/unique_values`, {
      table: tableTitle.title,
      column: column
    })
    console.log('Column clicked:', column)
    console.log('Column values:', response.data.values)
    setUniqueValues(response.data.values.join(', '))
  }

  // Optional: Function to handle form submission or input confirmation

  return (
    <div className="tspopup-overlay">
      <div className="tspopup-content">
        <div className="tspopup-header">
          <h5 className="tspopup-title">{tableTitle.title}</h5>
          <one-ux-icon
            size="500"
            class="tspopup-close"
            icon="close"
            slot="end"
            set="default"
            onClick={onClose}></one-ux-icon>
        </div>
        <one-ux-text>{tableTitle.context}</one-ux-text>

        <div className="tspopup-table">
          <table>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column} onClick={() => handleColumnClick(column)} style={{ cursor: 'pointer' }}>
                    {' '}
                    {column}{' '}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {columns.map((column, index) => (
                    <td key={column}>{row[index]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {unique_values.length > 0 && (
          <div>
            {' '}
            <one-ux-text>Unique values: </one-ux-text>
            <one-ux-text>{'\n' + unique_values}</one-ux-text>
          </div>
        )}
      </div>
    </div>
  )
}

export default TSPopup
